'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformListingsForExpandedDropdown = exports.transformDropdownInsurer = exports.transformDropdownTopSpecialties = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _developmentUrl = require('./development-url');

var _constants = require('./constants');

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var transformDropdownTopSpecialties = exports.transformDropdownTopSpecialties = function transformDropdownTopSpecialties() {
  var topSpecialties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var itemTransformer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (item) {
    return item;
  };

  var filterByWhiteList = function filterByWhiteList(item) {
    return Object.keys(_constants.DROPDOWN_TOP_SPECIALTIES_WEIGHTS).includes(item.name.toLowerCase());
  };
  var sortByWhiteListWeights = function sortByWhiteListWeights(a, b) {
    return _constants.DROPDOWN_TOP_SPECIALTIES_WEIGHTS[a.name.toLowerCase()] - _constants.DROPDOWN_TOP_SPECIALTIES_WEIGHTS[b.name.toLowerCase()];
  };

  return topSpecialties.filter(filterByWhiteList).sort(sortByWhiteListWeights).map(itemTransformer) || [];
};

var transformDropdownInsurer = exports.transformDropdownInsurer = function transformDropdownInsurer() {
  var insurers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var dropdownItems = [];

  dropdownItems.push({
    name: 'I am paying for myself'
  });

  return dropdownItems.concat(insurers.map(function (insurer) {
    insurer.iconUri = (0, _developmentUrl.getResourcePath)(insurer.icon_uri);
    return insurer;
  }));
};

var transformListingsForExpandedDropdown = exports.transformListingsForExpandedDropdown = function transformListingsForExpandedDropdown() {
  var listings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var itemTransformer = function itemTransformer(item) {
    return _extends({}, item, { type: item.keyword_type });
  };

  var specialties = transformDropdownTopSpecialties(listings.topLevelSpecialties, itemTransformer);

  var conditions = listings.popularConditions.map(itemTransformer) || [];
  var procedures = listings.popularProcedures.map(itemTransformer) || [];

  var specialists = listings.specialists || [];
  var practices = listings.practices || [];

  return [{
    name: 'Popular Specialties',
    isSectionHeader: true,
    type: 'specialty'
  }].concat(_toConsumableArray(specialties), [{
    name: 'Popular Conditions / Procedures',
    isSectionHeader: true,
    type: 'condition'
  }], _toConsumableArray(conditions), _toConsumableArray(procedures), _toConsumableArray(specialists), _toConsumableArray(practices));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/doctify-utils/lib/transformers.js
// module id = 1576
// module chunks = 0